import { QueryClient } from "@tanstack/react-query";
import { AxiosInstance } from "axios";
import { calculationKey, CalculationStatus } from "./calculationQuery";

export type CalculationConfirmInput = {
  id: number;
  idBusiness: number;
  idBranch: number | null;
  calculatedStartDate: string;
  calculatedEndDate: string;
  name: string;
  email: string;
  phone: string;
  memo: string;
  fileUrls: string[];
  calculationStatus: CalculationStatus;
  reasonOfDisapproval: string | null;
};

export const calculationConfirmMutation = (
  client: AxiosInstance,
  queryClient: QueryClient
) => ({
  mutationFn: (input: CalculationConfirmInput) =>
    client
      .request({
        method: "PUT",
        url: `v1/calculations/confirm/${input.id}`,
        data: input,
      })
      .then((response) => response.data),
  onSuccess: (_: unknown, input: CalculationConfirmInput) => {
    queryClient.invalidateQueries(calculationKey(input.id));
  },
});
